import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Select from "react-select";

import {
    uploadFileService,
    uploadToolkitFileService,
    deleteCakeDsignFileService,
    translateContentService,
    getDesignSubCategoryService,
    getDesignCategoryService,
    getToolkitDesignDetailByIdService,
    getDropDownCatsService,
    getProductUsedListService,
    updateToolkitDesignService,
    createToolkitDesignService,
    getDropDownCatsForToolkitService
} from "../../services/userService";

import { Spinner } from "react-bootstrap";
import { designAssetsList, getFileNameFromUrl } from "../helper";
import DeleteIcon from "../../assets/images/trash (1).svg";



const MarkingToolkitDesignForm = (key) => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [name, setName] = useState('');
    const [translated_name, setTranslated_name] = useState({});
    const [designFile, setDesignFile] = useState('');
    const [designFileView, setDesignFileView] = useState('');
    const [design_url, setDesign_url] = useState('');
    const [product_used, setProduct_used] = useState('');
    const [category_id, setCategory_id] = useState('');
    const [design_type, setDesign_type] = useState('');
    const [design_typeErr, setDesign_typeErr] = useState('');

    const [design_urlErr, setDesign_urlErr] = useState('');

    const [catList, setCatList] = useState([]);
    const [subCatList, setSubCatList] = useState([]);
    const [btnLoader, setBtnLoader] = useState(false);


    const [nameErr, setNameErr] = useState('');
    const [product_usedErr, setProduct_usedErr] = useState('');
    const [category_idErr, setCategory_idErr] = useState('');

    const [productUsedList, setProductUsedList] = useState([]);
    const [productCatList, setProductCatList] = useState([]);
    const [ocassionCatList, setOcassionCatList] = useState([]);
    const [flavouredCatList, setFlavouredCatList] = useState([]);
    const [productCat, setProductCat] = useState('');
    const [productCatErr, setProductCatErr] = useState([]);
    const [ocassionCat, setOcassionCat] = useState([]);
    const [flavouredCat, setFlavouredCat] = useState([]);

    useEffect(() => {
        const fetchCategories = async (categoryType, setState) => {
            const query = `?category_type=${categoryType}`;
            const res = await getDropDownCatsForToolkitService(query);
            if (res.data.statusCode) {
                setState(res.data.responseData.data);
            }
        };
        const getProductUsedList = async (categoryType, setState) => {
            const query = `?category_type=${categoryType}`;
            const res = await getProductUsedListService(query);
            if (res.data.statusCode) {
                setState(res.data.responseData.data);
            }
        };
    
        fetchCategories(1, setProductCatList);
        fetchCategories(2, setOcassionCatList);
        fetchCategories(3, setFlavouredCatList);
        getProductUsedList(4, setProductUsedList);
    }, []);



    const getCakeDesignDetail = () => {
        const query = `/?toolkit_id=${id}`;
        getToolkitDesignDetailByIdService(query).then((res) => {
            const responseData = res.data.responseData.data;
    
            setName(responseData.name);
            setDesignFileView(responseData.design_url);

            if(responseData.design_type){
                let design_type = {label: designAssetsList[responseData.design_type - 1], value: responseData.design_type};
                setDesign_type(design_type)
            }
    
            const sortCategories = (categories) => {
                return categories.sort((a, b) => a.label.localeCompare(b.label));
            };

            if(responseData.cake_type){
                setProduct_used({label: responseData.cake_type.name, value: responseData.cake_type._id})
            }


    
            const productCategories = sortCategories(responseData.category
                .filter(category => category.category_type === 1)
                .map(category => ({ label: category.category_name, value: category._id }))
            );
    
            const occasionCategories = sortCategories(responseData.category
                .filter(category => category.category_type === 2)
                .map(category => ({ label: category.category_name, value: category._id }))
            );
            const flavouredCategories = sortCategories(responseData.category
                .filter(category => category.category_type === 3)
                .map(category => ({ label: category.category_name, value: category._id }))
            );
            setProductCat(productCategories[0]);
            setOcassionCat(occasionCategories);
            setFlavouredCat(flavouredCategories);
        });
    };


    useEffect(() => {
        if(id){
            getCakeDesignDetail()
        }
    }, [id])


  
    const getDesignCategory = () => {
        let query = ``;
        getDesignCategoryService(query).then(res => {
            if(res.data.statusCode){
                setCatList(res.data.responseData.data);
            }
        })
    }

    const getDesignSubCategory = () => {
        let query = `?category_id=${category_id.value}`;
        getDesignSubCategoryService(query).then(res => {
            if(res.data.statusCode){
                setSubCatList(res.data.responseData.data);
            }
        })
    }

    useEffect(() => {
        if(category_id.value){
            getDesignSubCategory()
        }

    }, [category_id])



    useEffect(() => {
        getDesignCategory()
    }, [])




    const handleValidate = () => {
        let validate = true;

        if (!name) {
            setNameErr('Name is required');
            validate = false;
        }

        if (!product_used) {
            setProduct_usedErr('Product used is required');
            validate = false;
        }

        // if (!productCat.value) {
        //     setProductCatErr('Product category is required');
        //     validate = false;
        // }

        if (!design_type) {
            setDesign_typeErr('Design type is required');
            validate = false;
        }
       

        return validate;
    }


    const handleSubmit = async () => {
        if (handleValidate()) {
            try {
                setBtnLoader(true);


                const _name = await translateContentService({ text: name });
                const _translated_name = _name.data.responseData.data;



                let _url = '';

                if (designFile) {
                    const formData = new FormData();
                    formData.append("file", designFile);
                    formData.append("folderName", 'toolkit-design');
                    const __url = await uploadToolkitFileService(formData);
                    _url = __url.data.responseData;
                    setDesign_url(_url);
                }

                let all_cats = [...ocassionCat, ...flavouredCat];
                if(productCat.value){
                    all_cats.push(productCat);
                }

                let params = {
                    name,
                    translated_name: JSON.stringify(_translated_name),
                    cake_type: product_used.value,
                    design_type: design_type.value,
                    categories: all_cats.map(j => j.value),
                }

                if(_url){
                    params.design_url = _url.webp_file_url;
                    params.original_design_url = _url.file_url;
                }else{
                    params.design_url = designFileView
                }

                if(id){
                    params._id = id
                }

                let _service = id ? updateToolkitDesignService : createToolkitDesignService;
                const _res = await _service(params);
                setBtnLoader(false);
                if (_res.data.statusCode) {
                    navigate("/marking-toolkit-designs");
                }
                
            } catch (error) {
                console.error("Error:", error);
            }
        }
    };



    const handleFileChange = e => {
        let reader = new FileReader();
        let file = e.target.files[0];
        setDesignFile(file);
        
        reader.addEventListener('load', () => {
            setDesignFileView(reader.result);
        }, false);
        if (file) { reader.readAsDataURL(file) }
    }

    

    return (
        <>
            <div className="page_wrapper">
                    <div className="container-box">

                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="semibold-font mt-5">{id ? "Update" : "Add"} Marketing Toolkit Design</h4>
                        </div>
                       
                        <div className="tab-box position-relative">
                            <div className="add-product-box">
                                <div className="row">
                                    <div className="col-md-1"></div>
                                    <div className="col-md-5">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                className="form-control"
                                                value={name}
                                                onChange={e => (setName(e.target.value), setNameErr(''))}
                                                type="text" />

                                            {nameErr ? <div className="error-message">{nameErr}</div> : ''}
                                        </div>


                                        <div className="form-group">
                                            <label>Select Cake Type</label>
                                            <Select
                                                options={productUsedList.map(i => ({label: i.name, value: i._id}))}
                                                value={product_used}
                                                onChange={e => (setProduct_used(e), setProduct_usedErr(''))} />

                                            {product_usedErr ? <div className="error-message">{product_usedErr}</div> : ''}
                                        </div>


                                        <div className="form-group">
                                            <label>Select Offers</label>
                                            <Select
                                                options={productCatList.map(i => ({label: i.category_name, value: i._id}))}
                                                value={productCat}
                                                onChange={e => (setProductCat(e), setProductCatErr(''))} />

                                            {productCatErr ? <div className="error-message">{productCatErr}</div> : ''}
                                        </div>


                                        <div className="form-group">
                                            <label>Select Occasion</label>
                                            <Select
                                                isMulti
                                                options={ocassionCatList.map(i => ({label: i.category_name, value: i._id}))}
                                                value={ocassionCat}
                                                onChange={e => setOcassionCat(e)} />

                                            {category_idErr ? <div className="error-message">{category_idErr}</div> : ''}
                                        </div>


                                        <div className="form-group">
                                            <label>Select Flavour Festival</label>
                                            <Select
                                                isMulti
                                                options={flavouredCatList.map(i => ({label: i.category_name, value: i._id}))}
                                                value={flavouredCat}
                                                onChange={e => setFlavouredCat(e)} />

                                            {category_idErr ? <div className="error-message">{category_idErr}</div> : ''}
                                        </div>

                                        <div className="form-group">
                                            <label>Select Assets Type</label>
                                            <Select
                                                options={designAssetsList.map((i, ind) => ({label: i, value: ind + 1}))}
                                                value={design_type}
                                                onChange={e => (setDesign_type(e), setDesign_typeErr(''))} />

                                            {design_typeErr ? <div className="error-message">{design_typeErr}</div> : ''}
                                        </div>
                                        


                                        <div className="mt-5">
                                            <Link className="btn btn-dark me-4 px-5" to="/marking-toolkit-designs">CANCEL</Link>
                                            <span className="btn btn-primary me-4 px-5" onClick={btnLoader ? null : handleSubmit}>{btnLoader ? <Spinner className="spiner" animation="border" /> : ''} Save</span>
                                        </div>

                                    </div>

                                    <div className="col-md-5">
                                        <div className="form-group">
                                            <label>Upload Photo</label>
                                            <input
                                                multiple
                                                className="form-control"
                                                onChange={handleFileChange}
                                                type="file" />
                                                {design_urlErr ? <div className="cm_err">{design_urlErr}</div> : ''}
                                        </div>



                                    {designFileView ? <div className="desgin_banner">
                                            <img className="img-fluid" src={designFileView} />
                                        </div> : ''}
                                        


                                    
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
            </div>
        </>
    )
}
export default MarkingToolkitDesignForm;